var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"headBar"},[_c('headBar')],1),_c('div',{staticClass:"content"},[_c('carousel')],1),_c('div',{staticClass:"foot"},[_c('footBar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }